import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  autocompleteContainer: {
    minWidth: 200,
    '.MuiOutlinedInput-root': {
      minHeight: 'unset'
    }
  },
  tagsDisplayContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    border: `1px solid transparent`,
    paddingLeft: theme.spacing(0.5),
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    marginLeft: theme.spacing(-0.5),
    cursor: 'text',
    justifyContent: 'space-between',
    '&:hover': {
      borderColor: theme.vars.palette.divider
    },
    '&:hover .edit-icon': {
      opacity: 1
    }
  },
  tagsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5)
  },
  editIcon: {
    opacity: 0,
    transition: 'opacity 0.2s',
    marginLeft: theme.spacing(0.5)
  }
}));

export default useStyles;
